import React from 'react';
import { Direction } from '@prisjakt/ui';
import { Dropdown, DropdownContent } from '@prisjakt/ui/dropdown';
import { Behavior } from '@prisjakt/ui/text';
import { zindex } from 'src/ui/zindex';
import { SizeVariantsButtonLabel } from './size-variants-button-label';
import { SizeVariantsGrid } from './size-variants-grid';
import { IVariantsProps } from './types';
import { DropdownToggle, ButtonText } from './styles';

export const SizeVariantsDesktopVersion: React.FC<IVariantsProps> = props => {
  return (
    <Dropdown zIndex={zindex.modal}>
      <DropdownToggle showActiveIcon fullWidth>
        <ButtonText behavior={Behavior.OnelineEllipsis}>
          <SizeVariantsButtonLabel />
        </ButtonText>
      </DropdownToggle>
      <DropdownContent alignment={Direction.Down}>
        <SizeVariantsGrid {...props} />
      </DropdownContent>
    </Dropdown>
  );
};
